export const AUTOMATION_HEADER_RESPONSIVE_CSS = `
@container au-settings-panel (max-width: 630px) {
  .au-settings-panel .au-automation-header:has(.au-automation-header-actions) {
    align-items: flex-start;
  }

  .au-settings-panel .au-automation-header-actions {
    flex-basis: 100%;
  }
}
`;

const STYLE_ELEMENT_ID = "au-automation-header-responsive";

export const injectAutomationHeaderResponsiveStyles = (): void => {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById(STYLE_ELEMENT_ID) !== null) {
    return;
  }
  const style = document.createElement("style");
  style.id = STYLE_ELEMENT_ID;
  style.textContent = AUTOMATION_HEADER_RESPONSIVE_CSS;
  document.head.appendChild(style);
};
